import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const UpdateBlockModal = ({ show, onClose, data, refreshTable }) => {
  const [blockRooms, setBlockRooms] = useState("");
  const [blockFromDate, setBlockFromDate] = useState("");
  const [blockToDate, setBlockToDate] = useState("");
  const [remarks, setRemarks] = useState("");
  const [totalRooms, setTotalRooms] = useState("");
  const [blockRoomId, setBlockRoomId] = useState("");
  const [customerName, setCustomerName] = useState("");

  useEffect(() => {
    if (data) {
      // console.log('data is', data)
      setBlockRooms(data.BlockRooms || "");
      setBlockFromDate(data.blockFromDate ? data.blockFromDate.slice(0, 10) : "");
      setBlockToDate(data.blockToDate ? data.blockToDate.slice(0, 10) : "");
      setRemarks(data.remarks || data.Remarks || "");
      setCustomerName(data.customerName || data.CustomerName || "");
      setTotalRooms(data.totalRooms || "");
      setBlockRoomId(data.BookingRefNo || "");
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      const payload = {
        hotelId: data.hotelId,
        roomTypeId: data.roomTypeId,
        blockRoomId,
        totalRooms,
        blockRooms,
        blockFromDate,
        blockToDate,
        remarks,
        customerName,
      };

      const response = await axios.patch(
        `${REACT_APP_API_URL}api/dashboard/admin/room-blocking/edit`,
        payload
      );

      if (response.status === 200) {
        alert("Block updated successfully!");

        refreshTable();
        onClose();
      } else {
        alert("Failed to update block");
      }
    } catch (error) {
      console.error("Error updating block:", error);
      alert("Error updating block");
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal show fade"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content shadow-lg">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">Update Block</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Total Rooms</label>
              <input
                type="number"
                className="form-control"
                value={totalRooms}
                onChange={(e) => setTotalRooms(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Total Block Rooms</label>
              <input
                type="number"
                className="form-control"
                value={blockRooms}
                onChange={(e) => setBlockRooms(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Block From Date</label>
              <input
                type="date"
                className="form-control"
                value={blockFromDate}
                onChange={(e) => setBlockFromDate(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Block To Date</label>
              <input
                type="date"
                className="form-control"
                value={blockToDate}
                onChange={(e) => setBlockToDate(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Remarks</label>
              <input
                type="text"
                className="form-control"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Customer Name</label>
              <input
                type="text"
                className="form-control"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleSubmit}>
              Update
            </button>
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateBlockModal;
